import { render, staticRenderFns } from "./RemoveItemModal.vue?vue&type=template&id=61489368&"
import script from "./RemoveItemModal.vue?vue&type=script&lang=js&"
export * from "./RemoveItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61489368')) {
      api.createRecord('61489368', component.options)
    } else {
      api.reload('61489368', component.options)
    }
    module.hot.accept("./RemoveItemModal.vue?vue&type=template&id=61489368&", function () {
      api.rerender('61489368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/references/uniform-items/modals/RemoveItemModal.vue"
export default component.exports